if (!customElements.get('volume-discount')) {
  customElements.define(
    'volume-discount',
    class VolumeDiscount extends HTMLElement {
      constructor() {
        super();

        this.quantityInput = this.querySelector('[data-volume-discount-quantity]');
        this.tiers = this.querySelectorAll('.volume-discount__tier');

        this.tiers.forEach((tier) => {
          const radio = tier.querySelector('input[type="radio"]');
          if (!radio) return;

          radio.addEventListener('change', () => {
            if (radio.checked) {
              this.selectTier(tier);
            }
          });

          // Click on label/card also activates
          tier.addEventListener('click', (evt) => {
            // Native label behavior already toggles the radio, but we want
            // to ensure the active state updates even on touch devices.
            if (evt.target.tagName !== 'INPUT') {
              radio.checked = true;
              this.selectTier(tier);
            }
          });
        });
      }

      selectTier(tier) {
        // Update visual active state
        this.tiers.forEach((t) => t.classList.remove('volume-discount__tier--active'));
        tier.classList.add('volume-discount__tier--active');

        // Update hidden quantity input
        const quantity = tier.dataset.quantity;
        if (this.quantityInput && quantity) {
          this.quantityInput.value = quantity;
        }

        // Store discount code on the volume-discount element so the cart
        // interceptor can pick it up at submit time
        const discountCode = tier.dataset.discountCode || '';
        this.dataset.activeDiscountCode = discountCode;

        // Store extra-variant-ids (comma separated) so the cart interceptor
        // can add bundle extras (Lupe + Beutel) when this tier is selected
        const extraIds = tier.dataset.extraVariantIds || '';
        this.dataset.activeExtraVariantIds = extraIds;
      }

      getActiveDiscountCode() {
        return this.dataset.activeDiscountCode || '';
      }

      getActiveQuantity() {
        return this.quantityInput ? parseInt(this.quantityInput.value, 10) || 1 : 1;
      }

      getActiveExtraVariantIds() {
        // Returns array of {id, quantity}. Format on the element: "vid:qty,vid:qty"
        // Backwards compat: plain "vid,vid" still works (qty defaults to 1).
        const raw = this.dataset.activeExtraVariantIds || '';
        return raw
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean)
          .map((token) => {
            const [vidStr, qtyStr] = token.split(':');
            const id = parseInt(vidStr, 10);
            const quantity = parseInt(qtyStr, 10);
            return { id, quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1 };
          })
          .filter((o) => Number.isFinite(o.id));
      }
    }
  );
}
